import React from "react";
import { useEffect, useState } from "react";
import {
  Col,
  Button,
  FormGroup,
  Input,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";
import swal from "sweetalert";
import "react-datepicker/dist/react-datepicker.css";
import { LoadingOverlay } from "../../util/Helpers";
import { ACCESS_TOKEN, API_BASE_URL } from "../../constants";
import InvoiceUploadDetails from "./InvoiceUploadDetails";
import { saveUploadInvoiceItems } from "../../util/APIUtils";

export default function InvoiceUpload() {
  const [block, setBlock] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [invoice, setInvoice] = useState({});


  useEffect(() => { }, []);

  const handleUpload = (e) => {
    if (selectedFile) {
      setBlock(true);
      const formData = new FormData();
      formData.append(`file`, selectedFile);
      fetch(API_BASE_URL + "/invoiceRead/upload", {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ` + localStorage.getItem(ACCESS_TOKEN),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setBlock(false);
          swal({
            text: "File uploaded successfully",
          });
          setInvoice(data);
        })
        .catch((error) => {
          swal({
            text: "Something went wrong",
          });
          setBlock(false);
        });

    } else {
     // console.log(data);

      swal({
        text: "Please select file",
      });
    }
  };

  const clearAll = () => {
    setSelectedFile(null);
    setInvoice({});
    document.getElementById("file").value = "";
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === "application/pdf") {
        setSelectedFile(file);
      } else {
        swal({
          text: "Please select valid PDF fie",
        });
        clearAll();
      }
    }
  };

  const handleDeleteInvoiceItem = (index) => {
    const items = invoice.items.filter((item, i) => i !== index);
    setInvoice({ ...invoice, items: items });
  };

  const saveInvoice = () => {
    setBlock(true);
    saveUploadInvoiceItems(invoice).then((data) => {
      setBlock(false);
      swal({
        text: "Invoice saved successfully",
      });
      clearAll();
    }
    ).catch((error) => {
      swal({
        text: "Error" + error,
      });
      setBlock(false);
    });
  }
  return (
    <div>
      {block && <LoadingOverlay />}
      <Card>
        <CardHeader className="carheaderSmall">
          <strong>Invoice Upload </strong>
        </CardHeader>
        <CardBody>
          <FormGroup row>
            <Col md="3">
              <label>Invoice Upload </label>
            </Col>
            <Col xs="12" md="6">
              <Input
                type="file"
                name="file"
                id="file"
                accept=".csv"
                onChange={handleFileChange}
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Col md="3" />
            <Col md="3">
              <Button
                onClick={handleUpload}
                name="Submit"
                id="Submit"
                className="btn-info"
              >
                Upload
              </Button>
            </Col>
            <Col md="3">
              <Button
                onClick={clearAll}
                name="Submit"
                id="Submit"
                className="btn-warning"
              >
                Clear
              </Button>
            </Col>
          </FormGroup>
        </CardBody>
      </Card>
      {invoice && Object.keys(invoice).length > 0 && (
        <InvoiceUploadDetails partyName={invoice.partyName} invoiceNum={invoice.invoiceNum} invoiceDate={invoice.invoiceDate} items={invoice.items} onDelete={handleDeleteInvoiceItem} saveInvoice={saveInvoice} />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/InvoiceUpload.js